import type {
  DrawingRevisionOption,
  PageClassification,
} from 'features/knowledgeDocumentViewer/components/advancedSearch/utils/documentSearchApiSchemas'

export function revisionOptionClassification(
  option: DrawingRevisionOption | undefined
): PageClassification | undefined {
  return option?.page_classifications?.[0]
}

export function revisionOptionDocumentPage(
  option: DrawingRevisionOption | undefined
): { documentId: string; pageNum: number } | undefined {
  if (!option) return undefined
  const pageNum = revisionOptionClassification(option)?.page_num
  if (typeof pageNum !== 'number') return undefined
  return { documentId: option.document_id, pageNum }
}

export function revisionOptionPageNum(
  option: DrawingRevisionOption | undefined,
  fallbackPageNum: number
): number {
  return revisionOptionDocumentPage(option)?.pageNum ?? fallbackPageNum
}

export function documentPageKey(
  documentId: string,
  pageNum: number | string
): string {
  return `${documentId}:${pageNum}`
}
